import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getHourSlots } from '../../Constant.js'
import axios from 'axios'
import Toggle from 'react-toggle'
import ImageCropper from '../../common/ImageCropper/ImageCropper.js'
import GroupCheckbox from '../../common/GroupCheckbox/GroupCheckbox.js'
import Select from 'react-select'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import Quill from 'quill'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
import Button from '../../common/CustomComponents/Button.js'

// Extend Quill to handle Enter differently
const Block = Quill.import('blots/block')
Block.tagName = 'DIV'
Quill.register(Block, true)

const modules = {
  clipboard: {
    matchVisual: false,
  },
}

const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
  'color',
  'background',
  'align',
]

class ChaletAdd extends React.Component {
  state = {
    status: 'active',
    name_en: '',
    name_ar: '',
    desc_en: '',
    desc_ar: '',
    policy_en: '',
    policy_ar: '',
    refund_policy_en: '',
    refund_policy_ar: '',
    phone: '',
    img: '',
    popular_choice_img: '',
    minimum_price: '0',
    bathrooms: '0',
    bedrooms: '0',
    livingrooms: '0',
    lounges: '0',
    max_guests: '0',
    check_in_time: '',
    check_out_time: '',
    lat: '',
    long: '',
    address_en: '',
    address_ar: '',
    address_details_en: '',
    address_details_ar: '',
    // can_book_packages: false,
    can_book_individual_dates: false,
    // block_packages_dates: false,
    is_offer: false,
    // is_popular: false,
    // is_active: false,

    min_days: '',
    max_days: '',
    sunday_price: '',
    monday_price: '',
    tuesday_price: '',
    wednesday_price: '',
    thursday_price: '',
    friday_price: '',
    saturday_price: '',

    chalet_facilities: [],
    facilitiesList: [],

    selected_categories: [],
    categoriesList: [],

    isSaving: false,
    isData: false,
    Edit: false,
    popular_img: '',
    chalet_img: '',

    owner_id: '',
    ownerList: [],
    city_list: [],
    city_data: {},

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',

    b2c_commission_type: '',
    b2b_commission_type: '',
    b2b_commission: '',
    b2c_commission: '',
    price_before_markup: '',
  }

  async componentDidMount() {
    await this.getCities()
    setTimeout(() => {
      this.getFacilitiesList()
      this.getOwnerList()
      this.getChaletCategories()
      if (this.props.id) {
        this.getChaletDetails()
      }
    }, 100)
  }

  getChaletCategories = async () => {
    await axios
      .get(Constant.getAPI() + `/chalet/list-chalet-category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            categoriesList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getChaletDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/chalet/get-chalet-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const chaletData = res.data.data
          this.setState({
            ...chaletData,
            city_data: this.state.city_list.find((ele) => ele.value === chaletData?.city_id) || null,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getFacilitiesList = () => {
    axios
      .get(Constant.getAPI() + `/admin/get-facilities/chalet`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            facilitiesList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getOwnerList = () => {
    axios
      .get(Constant.getAPI() + `/admin/list-users/chalet-owner`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            ownerList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event, name) => {
    if (name === 'chalet_facilities') {
      this.setState({ chalet_facilities: event })
    } else if (name === 'selected_categories') {
      this.setState({ selected_categories: event })
    } else if (
      // event?.target?.name === 'is_active' ||
      event?.target?.name === 'is_offer' ||
      // event?.target?.name === 'is_popular' ||
      event?.target?.name === 'can_book_individual_dates'
      // event?.target?.name === 'can_book_packages'
      // event?.target?.name === 'block_packages_dates'
    ) {
      this.setState({ [event.target.name]: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  handleDescriptionChangeEn = (value) => {
    this.setState({
      desc_en: value,
    })
  }

  handleDescriptionChangeAr = (value) => {
    this.setState({
      desc_ar: value,
    })
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })

    if (imgKeyName == 'popular_choice_img') {
      this.setState({ popular_img: URL.createObjectURL(e) })
    } else {
      this.setState({ chalet_img: URL.createObjectURL(e) })
    }
  }

  onSaveData = () => {
    var that = this

    if (this.state.b2b_commission_type && (!this.state.b2b_commission || this.state.b2b_commission == 0)) {
      document.getElementById('b2b_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2B commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    if (this.state.b2c_commission_type && (!this.state.b2c_commission || this.state.b2c_commission == 0)) {
      document.getElementById('b2c_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2C commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    const formData = new FormData()

    formData.append('name_en', this.state.name_en)
    formData.append('name_ar', this.state.name_ar)
    formData.append('desc_en', this.state.desc_en)
    formData.append('desc_ar', this.state.desc_ar)
    formData.append('policy_en', this.state.policy_en)
    formData.append('policy_ar', this.state.policy_ar)
    formData.append('refund_policy_en', this.state.refund_policy_en)
    formData.append('refund_policy_ar', this.state.refund_policy_ar)
    formData.append('phone', this.state.phone)
    formData.append('max_days', this.state.max_days)
    formData.append('min_days', this.state.min_days)
    formData.append('sunday_price', this.state.sunday_price)
    formData.append('monday_price', this.state.monday_price)
    formData.append('tuesday_price', this.state.tuesday_price)
    formData.append('wednesday_price', this.state.wednesday_price)
    formData.append('thursday_price', this.state.thursday_price)
    formData.append('friday_price', this.state.friday_price)
    formData.append('saturday_price', this.state.saturday_price)
    // formData.append('can_book_packages', this.state.can_book_packages)
    // formData.append('block_packages_dates', this.state.block_packages_dates)
    formData.append('can_book_individual_dates', this.state.can_book_individual_dates)
    formData.append('minimum_price', this.state.minimum_price)
    formData.append('bathrooms', this.state.bathrooms)
    formData.append('bedrooms', this.state.bedrooms)
    formData.append('livingrooms', this.state.livingrooms)
    formData.append('lounges', this.state.lounges)
    formData.append('max_guests', this.state.max_guests)
    formData.append('check_in_time', this.state.check_in_time)
    formData.append('check_out_time', this.state.check_out_time)
    formData.append('lat', this.state.lat)
    formData.append('long', this.state.long)
    formData.append('address_en', this.state.address_en)
    formData.append('address_ar', this.state.address_ar)
    formData.append('address_details_en', this.state.address_details_en)
    formData.append('address_details_ar', this.state.address_details_ar)
    formData.append('is_offer', this.state.is_offer)
    // formData.append('is_popular', this.state.is_popular)
    // formData.append('is_active', this.state.is_active)
    formData.append('chalet_facilities', this.state.chalet_facilities)
    formData.append('selected_categories', this.state.selected_categories)
    formData.append('owner_id', this.state.owner_id)
    formData.append('city_id', this.state.city_data?.value || '')

    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)
    formData.append('h1_ar', this.state.h1_ar)
    formData.append('h1_en', this.state.h1_en)
    formData.append('h2_ar', this.state.h2_ar)
    formData.append('h2_en', this.state.h2_en)

    formData.append('b2b_commission_type', this.state.b2b_commission_type || '')
    formData.append('b2b_commission', this.state.b2b_commission || '')
    formData.append('b2c_commission_type', this.state.b2c_commission_type || '')
    formData.append('b2c_commission', this.state.b2c_commission || '')
    formData.append('price_before_markup', this.state.price_before_markup || '')

    that.setState({ isData: true })

    if (this.state.img?.type) {
      formData.append('img', this.state.img, 'your_original_filename.jpeg')
    }
    if (this.state.popular_choice_img?.type) {
      formData.append('popular_choice_img', this.state.popular_choice_img, 'your_original_filename.jpeg')
    }

    if (this.props.id) {
      formData.append('id', this.props.id)

      axios
        .put(Constant.getAPI() + '/chalet/update-chalet', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Chalet has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/chalet/add-chalet', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Chalet has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  getCities = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/city`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            city_list: res.data.data
              ?.filter((ele) => ele.is_deleted === false)
              .map((itm) => ({
                label: `${itm.name_en}/${itm.name_ar}`,
                value: itm.id,
              })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleCityChange = (event) => {
    this.setState({ city_data: event })
  }

  handleClear = () => {
    this.setState({ city_data: null })
  }
  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Chalet Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    id="name_en"
                    placeholder={`Chalet Name: English`}
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Chalet Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder={`Chalet Name: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Owner Of Chalet</label>
                <div className="col-sm-9">
                  <select
                    name="owner_id"
                    className="form-control"
                    value={this.state.owner_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Owner</option>
                    {this.state.ownerList
                      .sort((a, b) => a.first_name.localeCompare(b.first_name))
                      .map((item) => (
                        <option
                          value={item.id}
                          key={item.id}
                        >
                          {item.first_name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Coordinator Number</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="phone"
                    id="phone"
                    placeholder={`Contact Number`}
                    onChange={this.handleChange}
                    value={this.state.phone}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Select Area</label>
                <div className="col-sm-9">
                  <Select
                    name="city_data"
                    value={this.state.city_data}
                    onChange={this.handleCityChange}
                    options={this.state.city_list}
                    isMulti={false}
                    isSearchable={true}
                    isClearable
                    onClear={this.handleClear}
                    placeholder="Select Options"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="address_en"
                    id="address_en"
                    placeholder={`Address Area: Arabic`}
                    maxLength={25}
                    onChange={this.handleChange}
                    value={this.state.address_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.address_en ? this.state.address_en.length + ' / 25' : 0 + ' / 25'}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="address_ar"
                    id="address_ar"
                    placeholder={`Address Area: Arabic`}
                    maxLength={25}
                    onChange={this.handleChange}
                    value={this.state.address_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.address_ar ? this.state.address_ar.length + ' / 25' : 0 + ' / 25'}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address Details: English</label>
                <div className="col-sm-9">
                  <textarea
                    rows={3}
                    className="form-control"
                    onChange={this.handleChange}
                    name="address_details_en"
                    id="address_details_en"
                    maxLength={200}
                    placeholder=""
                    value={this.state.address_details_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.address_details_en ? this.state.address_details_en.length + ' / 200' : 0 + ' / 200'}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address Details: Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    rows={3}
                    className="form-control"
                    onChange={this.handleChange}
                    name="address_details_ar"
                    id="address_details_ar"
                    maxLength={200}
                    placeholder=""
                    value={this.state.address_details_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.address_details_ar ? this.state.address_details_ar.length + ' / 200' : 0 + ' / 200'}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Latitude</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="lat"
                    id="lat"
                    placeholder={`Latitude`}
                    onChange={this.handleChange}
                    value={this.state.lat}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Longitude</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="long"
                    id="long"
                    placeholder={`Longitude`}
                    onChange={this.handleChange}
                    value={this.state.long}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Check In Time</label>
                <div className="col-sm-9">
                  <select
                    name="check_in_time"
                    className="form-control"
                    value={this.state.check_in_time}
                    onChange={this.handleChange}
                  >
                    <option value="">Select time(HH:MM)</option>
                    {getHourSlots().map((item) => (
                      <option
                        value={item.value}
                        key={item.value}
                      >
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Check Out Time</label>
                <div className="col-sm-9">
                  <select
                    name="check_out_time"
                    className="form-control"
                    value={this.state.check_out_time}
                    onChange={this.handleChange}
                  >
                    <option value="">Select time(HH:MM)</option>
                    {getHourSlots().map((item) => (
                      <option
                        value={item.value}
                        key={item.value}
                      >
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Minimum Price</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="minimum_price"
                    id="minimum_price"
                    placeholder=""
                    onChange={this.handleChange}
                    value={this.state.minimum_price}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Bathrooms</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="bathrooms"
                    id="bathrooms"
                    placeholder=""
                    onChange={this.handleChange}
                    value={this.state.bathrooms}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Bedrooms</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="bedrooms"
                    id="bedrooms"
                    placeholder=""
                    onChange={this.handleChange}
                    value={this.state.bedrooms}
                  />
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
							<div className="form-group row">
								<label className="col-sm-3 col-form-label">Livingrooms</label>
								<div className="col-sm-9">
									<input
										type="number"
										className="form-control"
										name="livingrooms"
										id="livingrooms"
										placeholder=""
										onChange={this.handleChange}
										value={this.state.livingrooms}
									/>
								</div>
							</div>
						</div> */}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Lounges</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="lounges"
                    id="lounges"
                    placeholder=""
                    onChange={this.handleChange}
                    value={this.state.lounges}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Max Guests</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="max_guests"
                    id="max_guests"
                    placeholder=""
                    onChange={this.handleChange}
                    value={this.state.max_guests}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Commission</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2b_commission_type"
                    className="form-control"
                    value={this.state.b2b_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2b_commission"
                    id="b2b_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2b_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2c_commission_type"
                    className="form-control"
                    value={this.state.b2c_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2c_commission"
                    id="b2c_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2c_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price Before Markup</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="price_before_markup"
                    id="price_before_markup"
                    placeholder="Price Before Markup"
                    value={this.state.price_before_markup}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-12">
              <GroupCheckbox
                title={'Facilities'}
                list={this.state.facilitiesList}
                displayKey={'name_en'}
                idKey={'id'}
                selected={this.state.chalet_facilities}
                onChange={(event) => this.handleChange(event, 'chalet_facilities')}
              ></GroupCheckbox>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-12">
              <GroupCheckbox
                title={'Chalet Categories'}
                list={this.state.categoriesList}
                displayKey={'name_en'}
                idKey={'id'}
                selected={this.state.selected_categories}
                onChange={(event) => this.handleChange(event, 'selected_categories')}
              ></GroupCheckbox>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              {/* <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Day Wise Price</div> */}
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Book By Night</label>
                <div className="col-sm-9">
                  <Toggle
                    name="can_book_individual_dates"
                    id="can_book_individual_dates"
                    onChange={this.handleChange}
                    checked={this.state.can_book_individual_dates}
                  />
                </div>
              </div>
            </div>
            {this.state.can_book_individual_dates && (
              <>
                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                ></div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Min Days</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="min_days"
                        id="min_days"
                        placeholder="Min Days"
                        onChange={this.handleChange}
                        value={this.state.min_days}
                        min={1}
                        max={30}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Max Days</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="max_days"
                        id="max_days"
                        placeholder="Max Days"
                        onChange={this.handleChange}
                        value={this.state.max_days}
                        max={30}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                ></div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Sunday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="sunday_price"
                        id="sunday_price"
                        placeholder="Sunday Price "
                        onChange={this.handleChange}
                        value={this.state.sunday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Monday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="monday_price"
                        id="monday_price"
                        placeholder="Monday Price "
                        onChange={this.handleChange}
                        value={this.state.monday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Tuesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="tuesday_price"
                        id="tuesday_price"
                        placeholder="Tuesday Price "
                        onChange={this.handleChange}
                        value={this.state.tuesday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Wednesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="wednesday_price"
                        id="wednesday_price"
                        placeholder="Wednesday Price "
                        onChange={this.handleChange}
                        value={this.state.wednesday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Thursday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="thursday_price"
                        id="thursday_price"
                        placeholder="Thursday Price "
                        onChange={this.handleChange}
                        value={this.state.thursday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Friday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="friday_price"
                        id="friday_price"
                        placeholder="Friday Price "
                        onChange={this.handleChange}
                        value={this.state.friday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Saturday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="saturday_price"
                        id="saturday_price"
                        placeholder="Saturday Price "
                        onChange={this.handleChange}
                        value={this.state.saturday_price}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            {/* <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Can Book Packages</label>
                <div className="col-sm-9">
                  <Toggle
                    name="can_book_packages"
                    id="can_book_packages"
                    onChange={this.handleChange}
                    checked={this.state.can_book_packages}
                  />
                </div>
              </div>
            </div> */}
            {/* {
				this.state.can_book_packages && 
				<div className="col-md-6">
					<div className="form-group row">
						<label className="col-sm-3 col-form-label">Block Package dates from Individual dates</label>
						<div className="col-sm-9">
							<Toggle
								name="block_packages_dates"
								id="block_packages_dates"
								onChange={this.handleChange}
								checked={this.state.block_packages_dates}
							/>
						</div>
					</div>
				</div>
			} */}
            {/* <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Popular Choice</label>
                <div className="col-sm-9">
                  <Toggle
                    name="is_popular"
                    id="is_popular"
                    onChange={this.handleChange}
                    checked={this.state.is_popular}
                  />
                </div>
              </div>
            </div> */}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Show Offer Icon on item</label>
                <div className="col-sm-9">
                  <Toggle
                    name="is_offer"
                    id="is_offer"
                    onChange={this.handleChange}
                    checked={this.state.is_offer}
                  />
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Is Active</label>
                <div className="col-sm-9">
                  <Toggle
                    name="is_active"
                    id="is_active"
                    onChange={this.handleChange}
                    checked={this.state.is_active}
                  />
                </div>
              </div>
            </div> */}
            <div className="col-md-12"></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="desc_en"
                    id="desc_en"
                    modules={modules}
                    formats={formats}
                    value={this.state.desc_en}
                    onChange={this.handleDescriptionChangeEn}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="desc_ar"
                    id="desc_ar"
                    modules={modules}
                    formats={formats}
                    value={this.state.desc_ar}
                    onChange={this.handleDescriptionChangeAr}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Policy: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="policy_en"
                    id="policy_en"
                    value={this.state.policy_en}
                    onChange={(value) => {
                      this.setState({
                        policy_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Policy: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="policy_ar"
                    id="policy_ar"
                    value={this.state.policy_ar}
                    onChange={(value) => {
                      this.setState({
                        policy_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Refund Policy: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="refund_policy_en"
                    id="refund_policy_en"
                    value={this.state.refund_policy_en}
                    onChange={(value) => {
                      this.setState({
                        refund_policy_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Refund Policy: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="refund_policy_ar"
                    id="refund_policy_ar"
                    value={this.state.refund_policy_ar}
                    onChange={(value) => {
                      this.setState({
                        refund_policy_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Chalet Grid View Image</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Popular Choice Or Chalet List View Image</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={17 / 10}
                    img={this.state.popular_choice_img || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'popular_choice_img')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
              <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</h5>
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_en"
                      id="meta_title_en"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_title_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_ar"
                      id="meta_title_ar"
                      placeholder=" "
                      onChange={this.handleChange}
                      value={this.state.meta_title_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Keywords: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_en"
                      id="meta_keywords_en"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Keywords: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_ar"
                      id="meta_keywords_ar"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_en"
                      id="meta_desc_en"
                      value={this.state.meta_desc_en}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_ar"
                      id="meta_desc_ar"
                      value={this.state.meta_desc_ar}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_en"
                      id="h1_en"
                      placeholder="H1: English"
                      onChange={this.handleChange}
                      value={this.state.h1_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_ar"
                      id="h1_ar"
                      placeholder="H1: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h1_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_en"
                      id="h2_en"
                      placeholder="H2: English"
                      onChange={this.handleChange}
                      value={this.state.h2_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_ar"
                      id="h2_ar"
                      placeholder="H2: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h2_ar}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>
          </div>
          <div className="row float-right p-3">
            <Button
              disabled={this.state.isData}
              onClick={this.onSaveData}
              startIcon={<i className="icofont icofont-save"></i>}
            >
              {this.state.isData ? 'Saving...!' : 'Save'}
            </Button>
            <Button
              to={`/chalet-master`}
              variant="outlined"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default ChaletAdd
